<span class="avatar-container">
	<img *ngIf="avatar && !isLoading" [alt]="alt" [src]="avatar" [style.width]="width || '40px'" [style.height]="height || '40px'" class="avatar-image" />
	<div *ngIf="isLoading" class="avatar-loading" [style.width]="width || '40px'" [style.height]="height || '40px'">
		<ion-spinner name="crescent" size="small"></ion-spinner>
	</div>
	<img
		*ngIf="!avatar && !isLoading"
		[alt]="alt"
		src="assets/placeholder-avatar.png"
		[style.width]="width || '40px'"
		[style.height]="height || '40px'"
		class="avatar-placeholder"
	/>
</span>
